import { signOut } from '@firebase/auth';
import { AxiosError } from 'axios';
import i18next from 'i18next';
import { AlertTriangle, Lock } from 'lucide-react';

import { auth } from '../auth/firebase';
import { Button } from '../ui/button';

export interface ErrorFallbackProps {
  error: unknown;
  resetError: (...args: Array<unknown>) => void;
}

const ErrorFallbackContent = ({ error }: ErrorFallbackProps) => {
  if (error instanceof AxiosError) {
    if (error.response?.status === 404) {
      return (
        <>
          <AlertTriangle className="h-16 w-16 text-muted-foreground" />
          <h1 className="text-6xl font-extrabold mt-4">404</h1>
          <p className="mt-4 text-2xl font-semibold">{i18next.t('errors.not_found.title')}</p>
          <p className="mt-2 text-lg text-muted-foreground text-center">{i18next.t('errors.not_found.message')}</p>
        </>
      );
    }

    if (error.response?.status === 403) {
      return (
        <>
          <Lock className="h-16 w-16 text-muted-foreground" />
          <h1 className="text-6xl font-extrabold mt-4">403</h1>
          <p className="mt-4 text-2xl font-semibold">{i18next.t('errors.access_denied.title')}</p>
          <p className="mt-2 text-lg text-muted-foreground text-center">{i18next.t('errors.access_denied.message')}</p>
          <Button
            size="lg"
            type="button"
            variant="secondary"
            className="mt-4"
            onClick={async () => {
              await signOut(auth);

              window.location.href = '/sign-in';
            }}
          >
            Вибрати інший акаунт
          </Button>
        </>
      );
    }

    if (error.response?.data?.status === 'deprecated_payload') {
      return (
        <>
          <AlertTriangle className="h-16 w-16 text-muted-foreground" />
          <p className="mt-4 text-lg text-muted-foreground text-center">
            {i18next.t('errors.deprecated_payload.message')}
          </p>
          <Button size="lg" type="button" variant="secondary" className="mt-4" onClick={() => window.location.reload()}>
            {i18next.t('errors.deprecated_payload.action')}
          </Button>
        </>
      );
    }
  }

  return (
    <>
      <AlertTriangle className="h-16 w-16 text-muted-foreground" />
      <p className="mt-4 text-2xl font-semibold">{i18next.t('errors.generic.title')}</p>
      <p className="mt-2 text-lg text-muted-foreground text-center">{i18next.t('errors.generic.message')}</p>
    </>
  );
};

const ErrorFallback = (props: ErrorFallbackProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <ErrorFallbackContent {...props} />
    </div>
  );
};

export { ErrorFallback };
